import Vue from "vue";
import VueRouter from "vue-router";
import NoroView from "@/views/noro-view.vue";
import NoroEditView from "@/views/noro-edit-view.vue";
import store from "@/store/store";
import axios from "axios";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "noro-view",
    component: NoroView,
    meta: {
      permission: "",
      requiresAuth: false,
    },
  },
  {
    path: "/edit/:id",
    name: "noro-edit",
    component: NoroEditView,
    meta: {
      permission: "",
      requiresAuth: true,
    },
  },
  {
    path: "/edit",
    name: "noro-edit",
    component: NoroEditView,
    meta: {
      permission: "",
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login-page.vue"),
    meta: {
      permission: "",
      requiresAuth: false,
    },
  },
  {
    path: "/registration",
    name: "registration",
    component: () => import("../views/registration-page.vue"),
    meta: {
      permission: "",
      requiresAuth: false,
    },
  },
  {
    path: "/access-is-denied",
    name: "access-is-denied",
    component: () => import("../views/noPerm-page.vue"),
    meta: {
      permission: "",
      requiresAuth: false,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach(async (to, from, next) => {
  // если нет авторизации, получить ее по куки
  if (!store.getters.isLoggedIn) {
    await axios
      .post("/api/auth/check-auth")
      .then((resp) => {
        store.commit("auth_success", resp.data);
      })
      .catch(() => {});
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      if (to.meta.permission === "") {
        next();
        return;
      }
      checkPermission(store.getters.permissions, to.meta.permission)
        .then(() => {
          next();
        })
        .catch(() => {
          next({ name: "access-is-denied" });
        });
      return;
    }
    next("/login");
  } else {
    next();
  }
});

function checkPermission(permissions, toPerm) {
  return new Promise((resolve, reject) => {
    console.log(toPerm);
    if (permissions.indexOf(toPerm) !== -1) {
      resolve("");
    } else {
      reject("err");
    }
  });
}

export default router;
